<eup-error-page
	statusCode="404"
	errorHeader="{{'Errors.Error_404_Title' | translate}}"
    errorDescription="{{'Errors.Error_404_Message' | translate}}">
</eup-error-page>